import { registerSchema } from '@erikdakoda/utils/schemaRegistry';
import {
  AnalyzeOnboardingQuizSchema,
  OnboardingStructuredAnalysisSchema,
} from '../server/AnalyzeOnboardingQuizSchema';
import {
  AnalyzeLifeDomainQuizSchema,
  DomainStructuredAnalysisSchema,
} from '../server/AnalyzeLifeDomainQuizSchema';

/**
 * Registers quiz analyzer output schemas (Bot.outputSchema ids) and the structured-analysis
 * schemas stamped onto `QuizResult.analysisSchema`.
 * Always re-registers (HMR-safe) so schema edits replace the prior Zod contract.
 * Safe to call from app `initPackages` after vocabulary seeding.
 */
export function seedQuizAnalysisSchemas(): void {
  registerSchema({
    app: 'uvilo-ai',
    name: 'analyze-onboarding-quiz',
    version: 1,
    zodSchema: AnalyzeOnboardingQuizSchema,
    format: {},
  });

  registerSchema({
    app: 'uvilo-ai',
    name: 'analyze-life-domain-quiz',
    version: 1,
    zodSchema: AnalyzeLifeDomainQuizSchema,
    format: {},
  });

  registerSchema({
    app: 'uvilo-ai',
    name: 'onboarding-quiz-analysis',
    version: 1,
    zodSchema: OnboardingStructuredAnalysisSchema,
    format: {},
  });

  registerSchema({
    app: 'uvilo-ai',
    name: 'life-domain-quiz-analysis',
    version: 1,
    zodSchema: DomainStructuredAnalysisSchema,
    format: {},
  });
}
